<template>
  <div class="box">
    <div class="wrapper_box">
      <div class="charge_box">
        <div class="buff">{{ diyData }}</div>
        <div class="user_info">
          <img class="user_img" :src="userInfo.unionid ? userInfo.head_img : defaultImg" alt="" srcset="">
          <div class="welcome_nick_name">
            <div class="welcome_word">{{ nowTime }}，</div>
            <div class="nick_name">{{ userInfo.account }}, 欢迎您回到{{companyName}}</div>
            <div style="color: red;font-size: 14px;">本条栏目数据5分钟更新一次</div>
          </div>
        </div>
        <div class="data_box">
          <div class="month_charge">
            <span class="text">本月代充</span>
            <div class="num">
              ￥{{
                chargeObj.charge_pay_month > 0
                  ? chargeObj.charge_pay_month.toFixed(2)
                  : "0.00"
              }}
            </div>
          </div>
          <div class="month_charge">
            <div class="text">今日代充</div>
            <div class="num">
              ￥{{
                chargeObj.charge_pay_today > 0
                  ? chargeObj.charge_pay_today.toFixed(2)
                  : "0.00"
              }}
            </div>
          </div>
          <div class="month_charge">
            <div class="text">今日直充</div>
            <div class="num">
              ￥{{
                chargeObj.direct_pay_today > 0
                  ? chargeObj.direct_pay_today.toFixed(2)
                  : "0.00"
              }}
            </div>
          </div>
          <div class="month_charge">
            <div class="text">今日充值人数</div>
            <div class="num">
              {{ chargeObj.pay_user_today }}
            </div>
          </div>
          <div class="month_charge">
            <div class="text">本月流水</div>
            <div class="num">
              ￥{{ chargeObj.direct_pay_month > 0
              ? chargeObj.direct_pay_month.toFixed(2)
              : "0.00" }}
            </div>
          </div>

        </div>
      </div>
      <div class="home_con">
        <div>
          <div class="notice_box">
            <!-- <div class="title_box">
              <i style="color:#29d894" class="el-icon-message-solid"></i>
              <div class="title">公告列表</div>
            </div> -->
            <div class="notice_tabs">
              <div :class="['tabs_item', tabsCurrent == index ? 'a_tabs' : '']" :ref="'ref' + index"
                   v-for="(item, index) in noticeMenu" :key="index" @click="changeTabs(index, $event)">
                {{ item.label }}
                <div class="tab_dot" v-show="item.noRead > 0">{{item.noRead}}</div>
              </div>
              <div :style="{
                  width: lineWidth + 'px',
                  transform: 'translate(' + translate + 'px)'
                }" class="tabs_line"></div>
            </div>
            <div class="notice_con">
              <div class="notice_list_box" v-loading="!loading">
                <div class="notice_item" v-for="(v, k) in noticeList" :key="k" @click="seeNotice(v)">
                  <div class="item_title">
                    <div class="dot"></div>
                    <div class="title">
                      {{ v.post_title }}
                      <div class="red_dot" v-if="v.is_read == 0"></div>
                    </div>
                  </div>
                  <div class="time">{{ v.create_time }}</div>
                </div>
                <el-empty v-show="noticeList.length == 0 && loading" description="暂无公告~"></el-empty>
              </div>
              <div class="page_box" v-show="total > 5">
                <el-pagination :current-page="page" @current-change="currentChange" :page-size="5" background
                               layout="prev, pager, next" :total="total">
                </el-pagination>
              </div>
            </div>
          </div>
          <div class="per_top">
            <div class="title_more">
              <div class="title_per">推荐游戏</div>
              <!-- <div class="more" @click="$router.push({ name: 'datas', query: { type: 1 } })">
                更多排名 >
              </div> -->
            </div>
            <div class="fee_box" v-loading="!hotOver">
              <div class="fee_img" @click="dialogDetail=true" v-if="perList.length>0"
                   :style="{ backgroundImage: 'url('+ feeImg +')' }"></div>
              <div class="left_sroll" v-if="perList.length>0">
                <div class="scroll_box">
                  <div class="scroll_item" @click="dialogDetail=true" :style="{ opacity: hotCurrent==k ? '1' : '.7' }"
                       v-for="(v,k) in perList" :key="k" @mouseenter="mouseenter(v,k)">
                    <div class="fee_img_box" :style="{ border: hotCurrent==k ? '2px solid white' : 'none' }">
                      <img class="scroll_icon" :src="v.icon" alt="" srcset="">
                      <!-- <div v-if="v.is_can_accelerate" class="add_speed">加速</div> -->
                    </div>

                    <div class="item_info">
                      <div class="s_name_suffix">
                        <div class="s_name">{{ v.relation_game_name }}</div>
                        <div class="s_suffix" v-if="v.game_suffix">{{ v.game_suffix }}</div>
                      </div>
                      <div class="scroll_type">
                        <div class="s_type_item" v-for="(item, index) in v.game_type_name.split(',')" :key="index">
                          {{ item }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <img class="comer" :style="{top: comerMove + 'px'}" src="@/assets/index/jiao.png" alt="" srcset="">
                  <div style="height: 22px;"></div>
                </div>
              </div>
              <div class="scroll_desc" v-if="perList.length>0">{{ hotDesc }}</div>
              <el-button v-if="perList.length>0" class="scroll_btn" type="primary" icon="el-icon-plus"
                         @click="jumpExtension(gameId)">去推广</el-button>
              <el-empty class="no_data_per" v-if="perList.length == 0&&hotOver" description="暂无数据~"></el-empty>
            </div>

          </div>
        </div>
        <div class="new_today">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="今日开服" name="two">
              <div class="pane_box" v-loading="openLoading">
                <div>
                  <div class="new_game_box" v-for="(item, index) in openList" :key="index"
                       @click="jumpExtension(item.gid)">
                    <div class="new_icon_box">
                      <img class="new_icon" :src="item.icon" alt="" srcset="" />
                      <!-- <div v-if="item.is_can_accelerate" class="add_speed">加速</div> -->
                    </div>

                    <div class="new_info">
                      <div class="new_name_suffix">
                        <div class="name">{{ item.game_name }}</div>
                        <div class="suffix" v-if="item.game_suffix">
                          {{ item.game_suffix }}
                        </div>
                      </div>
                      <div class="type_plat">
                        <div class="type_box">
                          <div class="type_item" v-for="(v, k) in item.game_type_name.split(',')" :key="k">
                            {{ v }}
                          </div>
                        </div>
                        <div class="plat_box">
                          <img class="plat_icon" v-if="item.sdk_version == 2 || item.sdk_version == 10"
                               src="@/assets/extension/ios.png" alt="" srcset="" />
                          <img class="plat_icon" v-if="item.sdk_version == 1 || item.sdk_version == 10"
                               src="@/assets/extension/and.png" alt="" srcset="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <el-empty class="no_data" v-if="openList.length == 0" description="暂无今日开服~"></el-empty>
                </div>
                <div class="more_box" v-if="openList.length > 0" @click="$router.push({ name: 'openServe' }, () => {})">
                  更多开服 >>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- <div class="home_right">
          <div class="quick_box">
            <div class="quick_top">
              <div class="title">快速开始/便捷导航</div>
            </div>
            <div class="menu_box" v-loading="menuLoading">
              <div class="menu_item" v-for="(v, k) in menuList" :key="k" @click="jumpMenu(v, k)">
                <img :src="v.icon" class="menu_img" alt="" srcset="" />
                <div class="menu_word">{{ v.name }}</div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- 新游来袭 -->
      <div class="new_game_wap" v-if="newList.length>0">
        <div class="title_more">
          <div class="title_per">新游来袭</div>
          <div class="more" @click="jumpNew">
            查看全部新游 >
          </div>
        </div>
        <div class="new_game_con">
          <div class="new_game_item" v-for="(v,k) in newList" :key="k" @click="gameId=v.game_id,dialogDetail=true">
            <div class="img_box">
              <img class="img_new" :src="v.video_cover" alt="" srcset="">
            </div>
            <div class="new_img_info">
              <div class="new_img_box">
                <img class="img_icon" :src="v.icon" alt="" srcset="">
                <!-- <div v-if="v.is_can_accelerate" class="add_speed">加速</div> -->
              </div>

              <div class="new_info">
                <div class="game_suffix">
                  <div class="game">{{ v.relation_game_name }}</div>
                  <div class="suffix" v-if="v.game_suffix">{{ v.game_suffix }}</div>
                </div>
                <div class="new_types">
                  <div class="new_type_item" v-for="(item,index) in v.game_type_name.split(',')" :key="index">{{ item }}
                  </div>
                </div>
                <!-- <div class="desc">{{v.promote_declare}}</div> -->
                <div class="serve_time">
                  <div class="serve">{{ v.next_server }}</div>
                  <div class="time">{{ v.next_server_time }}</div>
                </div>
              </div>
              <el-button class="go_btn" size="mini" type="primary"
                         @click.stop="jumpExtension(v.game_id)">去推广</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 公告详情 -->
    <el-dialog :title="noticeTitle" top="100px" :visible.sync="dialogNotice" custom-class="notice_height" width="50%"
               @close="closeNotice">
      <div class="notice_dia">
        <ywater-mark></ywater-mark>
        <div class="notice_con" v-html="noticeCon"></div>
      </div>

    </el-dialog>
    <!-- 菜单修改 -->
    <el-dialog :show-close="false" class="dia_menu" top="40px" :visible.sync="dialogMenu" width="1085px">
      <div class="dialog_menu_box">
        <div class="menu_top">
          <div class="menu_title_box">
            <div class="menu_title">已添加</div>
            <div class="title_tip">可添加6个</div>
          </div>
          <div class="search_box">
            <div class="s_input">
              <el-input v-model="menuName" placeholder="请输入菜单名称" @input="changeSearch" clearable
                        @blur="searchSuccess=false" @focus="searchSuccess=true"></el-input>
              <div class="result_box" v-if="searchMenuList.length>0&&menuName.length>0&&searchSuccess">
                <div class="res_item" v-for="(item,index) in searchMenuList" :key="index"
                     @mousedown="(dialogMenu = false), menuName='',$router.push({ path: item.url })">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="dmenu_box">
          <div class="dmenu_item" v-for="(v, k) in diaMenuList" :key="k"
               @click="(dialogMenu = false), $router.push({ path: v.url })">
            <div class="dmenu_left">
              <img class="dmenu_icon" :src="v.icon" alt="" srcset="" />
              <div class="dmenu_name">{{ v.name }}</div>
            </div>
            <div class="dmenu_right" @click.stop="removeMenu(k)">
              <el-button size="mini" plain>移除</el-button>
            </div>
          </div>
        </div>
        <div class="menu_title_box">
          <div class="menu_title">服务应用</div>
        </div>
        <div class="dmenu_box">
          <div class="dmenu_item" v-for="(v, k) in serveList" :key="k">
            <div class="dmenu_left" @click="(dialogMenu = false), $router.push({ path: v.url })">
              <img class="dmenu_icon" :src="v.icon" alt="" srcset="" />
              <div class="dmenu_name">{{ v.name }}</div>
            </div>
            <div class="dmenu_right">
              <el-button size="mini" type="primary" plain :disabled="!v.show"
                         @click.stop="serviceCheck(v)">添加</el-button>
            </div>
          </div>
        </div>
        <div class="menu_title_box">
          <div class="menu_title">系统应用</div>
        </div>
        <div class="dmenu_box">
          <div class="dmenu_item" v-for="(v, k) in sysList" :key="k">
            <div class="dmenu_left" @click="(dialogMenu = false), $router.push({ path: v.url })">
              <img class="dmenu_icon" :src="v.icon" alt="" srcset="" />
              <div class="dmenu_name">{{ v.name }}</div>
            </div>
            <div class="dmenu_right">
              <el-button size="mini" type="primary" plain :disabled="!v.show" @click.stop="sysCheck(v)">添加</el-button>
            </div>
          </div>
        </div>
        <div class="menu_title_box">
          <div class="menu_title">数据应用</div>
        </div>
        <div class="dmenu_box">
          <div class="dmenu_item" v-for="(v, k) in dataList" :key="k">
            <div class="dmenu_left" @click="(dialogMenu = false), $router.push({ path: v.url })">
              <img class="dmenu_icon" :src="v.icon" alt="" srcset="" />
              <div class="dmenu_name">{{ v.name }}</div>
            </div>
            <div class="dmenu_right">
              <el-button size="mini" type="primary" plain :disabled="!v.show" @click.stop="dataCheck(v)">添加</el-button>
            </div>
          </div>
        </div>
        <div class="menu_title_box" v-if="cashList.length>0">
          <div class="menu_title">提现管理</div>
        </div>
        <div class="dmenu_box" v-if="cashList.length>0">
          <div class="dmenu_item" v-for="(v, k) in cashList" :key="k">
            <div class="dmenu_left" @click="(dialogMenu = false), $router.push({ path: v.url })">
              <img class="dmenu_icon" :src="v.icon" alt="" srcset="" />
              <div class="dmenu_name">{{ v.name }}</div>
            </div>
            <div class="dmenu_right">
              <el-button size="mini" type="primary" plain :disabled="!v.show" @click.stop="cashCheck(v)">添加</el-button>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogMenu = false">取 消</el-button>
        <el-button type="primary" @click="confirmEdit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 实名认证 -->
    <auth :dialogAuth.sync="dialogAuth" :out="true" :force="true" :userInfo="userInfo"></auth>

    <el-dialog title="重要公告" :visible.sync="dialogImpont" width="400px">
      <div class="notice_con" @click="prevImg($event)" v-html="noticeImponent"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="know">我知道了</el-button>
      </span>
    </el-dialog>
    <!-- 游戏详情 -->
    <game-detail :dialogDetail.sync="dialogDetail" :id="gameId"></game-detail>
    <el-dialog title="法大大合同签署" :visible.sync="dialogContract" width="30%" :show-close="false"
               :close-on-click-modal="false" :close-on-press-escape="false" class="contract_dialog">
      <div>
        <div>根据平台规定，使用本渠道推广后台需要签署法大大合同,如拒绝认证签署，将无法进行后续操作，共两步,请按顺序操作</div>
        <div class="contract_tip" style="margin-top: 5px;">认证方式选择实名手机号必须是本人实名认证过的才可以，否则会认证失败</div>
        <div class="contract_tip" style="margin-top: 15px;">1.法大大用户认证</div>
        <div class="contract_tip">2.法大大合同签署</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goAuth" v-if="contract_open_uid==''">用户认证</el-button>
        <el-button type="primary" @click="goSign" :loading="loadingSign">合同签署</el-button>
        <el-button type="success" @click="overContract">已完成签署</el-button>
      </span>
    </el-dialog>
    <phone :dialogPhone.sync="dialogPhone" :userInfo="userInfo"></phone>
  </div>
</template>
<script>
  import {
    index,
    notice,
    noticeDetail,
    homeMenu,
    updateMenu,
    adminAllUsers,
    serverList
  } from "@/api/home";
  import {
    topList,
    gameList
  } from "@/api/extension";
  import {
    getUser,
    wxLogin
  } from "@/api/login";
  import {
    getAuthUrl,
    createSignContract
  } from "@/api/user"
  import {
    throttle
  } from '@/utils/public'
  import auth from "@/component/my/auth_name.vue";
  import backSend from "@/component/home/admin_send.vue";
  import login from "@/component/login.vue";
  import ywaterMark from '@/component/ywaterMark.vue'
  import phone from '@/component/my/phone.vue'
  import {
    mapGetters
  } from "vuex";
  import {
    serveList,
    sysList,
    dataList,
    cashList
  } from "@/utils/menu";
  // let ver = require('../../../package.json').version
  export default {
    name: "home",
    components: {
      auth,
      backSend: () => import("@/component/home/admin_send.vue"),
      promoteSend: () => import("@/component/home/promote_send.vue"),
      gameDetail: () => import("@/component/game_detail.vue"),
      login,
      ywaterMark,
      phone
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    data() {
      return {
        loadingSign: false,
        contract_open_uid: '',
        dialogPhone: false,
        contractAuthUrl: '',
        contractSignUrl: '',
        dialogContract: false,
        dialogDetail: false,
        dialogBack: false,
        dialogModal: false,
        dialogInner: false,
        dialogPro: false,
        chargeObj: {},
        noticeMenu: [{
            label: "官方公告",
            name: "official",
            type: 1,
            isRead: 1
          },
          {
            label: "新游公告",
            name: "new",
            type: 2,
            isRead: 1
          },
          {
            label: "下架公告",
            name: "down",
            type: 3,
            isRead: 1
          }
        ],
        tabsCurrent: 0,
        lineWidth: 0,
        translate: 0,
        activeName: "two",
        promote_type: 1,
        page: 1,
        noticeList: [],
        loading: false,
        total: 0,
        dialogNotice: false,
        noticeTitle: "",
        noticeCon: "",
        menuList: [],
        diaMenuList: [],
        serveList: serveList,
        sysList: sysList,
        dataList: dataList,
        cashList: [],
        dialogMenu: false,
        dialogAuth: false,
        offsetLeft: 0,
        isBack: true,
        perList: [],
        startX: 0,
        endX: 0,
        newList: [],
        openList: [],
        dialogImpont: false,
        noticeImponent: "",
        article_id: "",
        nowTime: '',
        feeImg: '',
        hotCurrent: 0,
        comerMove: 35,
        hotDesc: '',
        gameId: '',
        hotOver: false,
        menu_hidden: [],
        companyName: '',
        diyData: '推广数据',
        defaultImg: 'https://ttxres.ttxgm.com/site/20240319/160d17948e06a0360b5f733f4ded7cca.png',
        dbState: true,
        menuLoading: false,
        menuName: '',
        searchMenuList: [],
        searchSuccess: false,
        openLoading: true
      };
    },
    created() {
      if (this.$route.query.type == "login") {
        this.$parent.current = 0;
      }
      this.homeData()
      // await this.getNotice();
      // await this.getPer();
      // await this.getNewGame();
      // await this.getTodayOpen();
      if (this.userInfo.is_force_name == 1 && !this.userInfo.auth_real_name) {
        this.dialogAuth = true;
      }
      this.contractSign()
    },
    activated() {
      // this.getPer();
      let nowTime = new Date().getHours()
      if (nowTime < 12) {
        this.nowTime = '上午好'
      } else if (nowTime == 12) {
        this.nowTime = '中午好'
      } else if (nowTime < 18) {
        this.nowTime = '下午好'
      } else {
        this.nowTime = '晚上好'
      }
      if (this.perList.length > 0) {
        this.hotCurrent = 0
        this.comerMove = 35

        this.feeImg = this.perList[0].video_cover
        this.hotDesc = this.perList[0].features
        this.gameId = this.perList[0].game_id
      }
      // this.hotCurrent = 0
      // this.comerMove = 35

      // this.feeImg = this.perList[0].video_cover
      // this.hotDesc = this.perList[0].features
      // this.gameId = this.perList[0].game_id
      this.getData();
      this.companyName = this.$parent.companyName || '凸凸虾游戏'
      let cashRole = this.userInfo.trade_limit
      switch (cashRole) {
        case 1:
          this.cashList = [{
              name: "余额发布列表",
              icon: "https://ttxres.ttxgm.com/promote_zs_static/commission_detail.png",
              url: "/mine/sum_list",
              id: 29,
              show: false
            },
            {
              name: "余额购买记录",
              icon: "https://ttxres.ttxgm.com/promote_zs_static/commission_detail.png",
              url: "/mine/money_buy_record",
              id: 30,
              show: false
            }
          ];
          break;
        case 2:
          this.cashList = [{
            name: "余额提现",
            icon: "https://ttxres.ttxgm.com/promote_zs_static/commission_t.png",
            url: "/mine/cash",
            id: 7,
            show: false
          }];
          break;
        case 3:
          this.cashList = cashList;
          break;
        default:
          this.cashList = [];
      }

    },
    mounted() {
      this.$nextTick(() => {
        let ref = "ref" + this.tabsCurrent;
        this.offsetLeft = this.$refs[ref][0].getBoundingClientRect().left; //获取第一个元素距离左边距离
        this.lineWidth = this.$refs[ref][0].offsetWidth; //获取当前元素宽度 （当前元素宽度=底部线条宽度）

      });
    },
    methods: {
      changeSearch(v) {
        this.searchMenuList = []
        this.$tools.debounce(() => {
          if (v.length > 0) {
            let arr = []
            let allMenu = [...this.serveList, ...this.sysList, ...this.dataList, ...this.cashList]
            for (let i = 0; i < allMenu.length; i++) {
              if (allMenu[i].name.indexOf(this.menuName) >= 0) {
                arr.push(allMenu[i])
              }
            }
            this.searchMenuList = arr
            this.searchSuccess = true
          }
        }, 600)()
      },
      //法大大合同签署
      async contractSign() {
        let user = await getUser()
        this.contract_open_uid = user.data.contract_open_uid
        if (user.data.contract_sign_status == 0 && user.data.is_force_contract == 1) {
          if (user.data.contract_open_uid == '') {
            getAuthUrl().then(res => {
              console.log(res)
              if (res.code == 200) {
                this.contractAuthUrl = res.data.authShortUrl
              }
            })
          }
          this.dialogContract = true
        }
      },
      goAuth() {

        if (this.userInfo.mobile_phone == '') {
          this.$message({
            message: '请先绑定手机号',
            type: 'warning'
          });
          this.dialogPhone = true
          return
        }
        if (this.userInfo.auth_real_name == '') {
          this.$message({
            message: '请先进行实名认证',
            type: 'warning'
          });
          this.dialogAuth = true
          return
        }
        window.open(this.contractAuthUrl, '_blank')
      },
      overContract() {
        getUser().then(res => {
          if (res.code == 200) {
            if (res.data.contract_sign_status == 1) {
              this.dialogContract = false
              this.$store.dispatch("getUserInfo", res.data);
            } else {
              this.$message({
                message: '合同未签署',
                type: 'warning'
              });
            }
          }
        })
      },
      goSign() {
        this.loadingSign = true
        getUser().then(res => {
          if (res.code == 200) {
            if (res.data.contract_open_uid == '') {
              return this.$message({
                message: '请先完成合同认证',
                type: 'warning'
              });
            }
            createSignContract().then(res => {
              if (res.code == 200) {
                window.open(res.data.actorSignTaskUrl, '_blank')
              }
              this.loadingSign = false
            })
          }
        })

      },
      mouseenter(v, k) {
        this.hotCurrent = k
        this.comerMove = 35 * (k + 1) + 35 * k
        this.feeImg = v.video_cover
        this.hotDesc = v.features
        this.gameId = v.game_id
        // const scrollEl = this.$el.querySelector(
        //   '.scroll_box'
        // )
        // if (k > 3) {
        //   scrollEl.scrollTop = (k - 3) * 70
        // } else {
        //   scrollEl.scrollTop = 0
        // }
      },
      goPromote() {
        this.$router.push({
          name: 'extension',
          query: {
            keyword: this.gameId,
            type: 'topSearch'
          }
        }, () => {})
      },
      //type:1后台发放 2渠道发放
      send(type) {
        if (type == 1) {
          this.isBack = true;
        } else {
          this.isBack = false;
        }
        let admin = localStorage.getItem("adminUser");
        if (admin) {
          // admin.admin_token
          admin = JSON.parse(admin);
          let parma = {
            page: 1,
            limit: 10,
            user_account: "",
            admin_token: admin.admin_token
          };
          adminAllUsers(parma).then(res => {
            if (res.code == 20001 || res.code == 1001) {
              this.dialogInner = true;
              localStorage.removeItem("adminUser");
            }

            if (res.code == 200) {
              this.dialogModal = false;
              if (type == 1) {
                this.dialogBack = true;
              } else {
                this.dialogPro = true;
              }
            }
          });
        } else {
          this.dialogInner = true;
        }
      },

      //会长代充
      jumph() {
        this.dialogModal = false;
        this.$router.push({
          name: "substitute"
        });
      },
      //内团登录成功
      loginSuccess() {
        this.dialogInner = false;
        this.dialogModal = false;
        setTimeout(() => {
          this.$message({
            message: "登录成功",
            type: "success"
          });
        }, 200);
        if (this.isBack) {
          this.dialogBack = true;
        } else {
          this.dialogPro = true;
        }
      },
      //公告类型切换
      changeTabs(k, v) {
        this.tabsCurrent = k;
        let ref = "ref" + k;
        this.translate = Math.floor(
          this.$refs[ref][0].getBoundingClientRect().left - this.offsetLeft
        );
        this.lineWidth = this.$refs[ref][0].offsetWidth;
        this.promote_type = this.noticeMenu[k].type;
        this.page = 1;
        this.getNotice();
      },
      closeNotice() {
        this.getNotice();
      },
      getNewGame() {

      },
      //今日开服
      getTodayOpen() {

      },
      menuInit() {
        let [serveIds, sysIds, dataIds, cashIds] = [
          [],
          [],
          [],
          []
        ];

        this.diaMenuList.forEach(v => {
          this.serveList.forEach((vv, kk) => {
            if (v.id == vv.id) {
              serveIds.push(v.id);
              vv.show = true;
            }
          });
        });
        this.diaMenuList.forEach(v => {
          this.sysList.forEach((vv, kk) => {
            if (v.id == vv.id) {
              sysIds.push(v.id);
              vv.show = true;
            }
          });
        });
        this.diaMenuList.forEach(v => {
          this.dataList.forEach((vv, kk) => {
            if (v.id == vv.id) {
              dataIds.push(v.id);
              vv.show = true;
            }
          });
        });
        this.diaMenuList.forEach(v => {
          this.cashList.forEach((vv, kk) => {
            if (v.id == vv.id) {
              cashIds.push(v.id);
              vv.show = true;
            }
          });
        });
        this.serveList.forEach(v => {
          if (serveIds.includes(v.id)) {
            v.show = false;
          } else {
            v.show = true;
          }
        });
        this.sysList.forEach(v => {
          if (sysIds.includes(v.id)) {
            v.show = false;
          } else {
            v.show = true;
          }
        });
        this.dataList.forEach(v => {
          if (dataIds.includes(v.id)) {
            v.show = false;
          } else {
            v.show = true;
          }
        });
        this.cashList.forEach(v => {
          if (cashIds.includes(v.id)) {
            v.show = false;
          } else {
            v.show = true;
          }
        });
      },
      getData() {
        index().then(res => {
          this.chargeObj = res.data.statistics;
          if (res.data.gonggao.length > 0) {
            this.dialogImpont = true;
            this.noticeImponent = res.data.gonggao[0].post_content;
            this.article_id = res.data.gonggao[0].article_id;
          }
          this.menu_hidden = res.data.menu_hidden
          let newSysList = sysList.filter(v => {
            return !res.data.menu_hidden.includes(v.id)
          })
          this.sysList = newSysList
          let newDataList = dataList.filter(v => {
            return !res.data.menu_hidden.includes(v.id)
          })
          this.dataList = newDataList
          this.$parent.sysList = newSysList
          this.$parent.dataList = newDataList
          this.getMenu();
        });
      },
      know() {
        noticeDetail({
          article_id: this.article_id
        }).then(res => {
          if (res.code == 200) {
            this.dialogImpont = false;
          }
        });
      },
      currentChange(v) {
        this.page = v;
        this.getNotice();
      },
      async homeData() {
        this.loading = false;
        await notice({
          promote_type: this.promote_type,
          page: this.page,
          limit: 10
        }).then(res => {
          this.noticeList = res.data.data;
          this.total = res.data.data_count;
          this.loading = true;
          this.noticeMenu.forEach((v, k) => {
            if (k == 0) {
              this.$set(v, "isRead", res.data.gf_is_read);
            }
            if (k == 1) {
              this.$set(v, "isRead", res.data.newgame_is_read);
            }
            if (k == 2) {
              this.$set(v, "isRead", res.data.off_is_read);
            }
          });
        });
        let params = {
          page: 1,
          limit: 15,
          type: 3
        };
        this.hotOver = false
        await topList("/game/down_game_list", params).then(res => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              this.perList = res.data;
              this.feeImg = res.data[0].video_cover
              this.hotDesc = res.data[0].features
              this.gameId = res.data[0].game_id
            }
            this.hotOver = true
          }
        });
        await gameList("/game/today_new_game", {
          page: 1,
          limit: 10
        }).then(res => {
          this.newList = res.data
        });
        await serverList({
          type: "",
          server: 3,
          time: ""
        }).then(res => {
          if (res.data.server) {
            let arrayData = res.data.server.flat(Infinity);
            arrayData.map(v => {
              v.game.map(vv => {
                this.openList.push(vv);
              });
            });
          }

          this.openList = this.openList.slice(0, 5);
          this.openLoading = false;
        });
      },
      getNotice() {
        this.loading = false;
        notice({
          promote_type: this.promote_type,
          page: this.page,
          limit: 5
        }).then(res => {
          this.noticeList = res.data.data;
          this.total = res.data.data_count;
          this.loading = true;
          this.noticeMenu.forEach((v, k) => {
            if (k == 0) {
              this.$set(v, "isRead", res.data.gf_is_read);
            }
            if (k == 1) {
              this.$set(v, "isRead", res.data.newgame_is_read);
            }
            if (k == 2) {
              this.$set(v, "isRead", res.data.off_is_read);
            }
          });
        });
      },
      handleClick(tab, event) {
        this.activeName = tab.name;
      },
      format(v) {
        for (let s of this.noticeMenu) {
          if (s.name == v) {
            return s.type;
          }
        }
      },
      seeNotice(v) {
        noticeDetail({
          article_id: v.article_id
        }).then(res => {
          this.noticeTitle = res.data.post_title;
          this.noticeCon = res.data.post_content;
          this.dialogNotice = true;
        });
      },
      getMenu() {
        this.menuLoading = true
        homeMenu().then(res => {
          let data = JSON.parse(res.data);
          data.splice(3, 0, {
            icon: "https://ttxres.ttxgm.com/promote_zs_static/daic.png",
            name: "会长代充",
            url: "/home/substitute"
          });
          data.push({
            icon: "https://ttxres.ttxgm.com/promote_zs_static/more_a.png",
            name: "更多应用",
            url: "/home/more_apply"
          });
          let newMenu = data.filter(v => {
            return !this.menu_hidden.includes(v.id)
          })
          this.menuList = newMenu

          // this.menuList = data;
          this.diaMenuList = JSON.parse(res.data);
          this.menuInit();
          this.diaMenuList = this.diaMenuList.filter(v => {
            return !this.menu_hidden.includes(v.id)
          })
          this.menuLoading = false
        });
      },
      //人气排名
      getPer() {

      },
      mousedown(e) {
        this.startX = e.clientX;
      },
      mouseup(e) {
        this.endX = e.clientX;
      },
      jumpMenu(v, k) {
        let last = this.menuList.length - 1
        if (k == last) {
          if (this.userInfo.promote_level == 1) {
            let isQu = this.serveList.some(v => {
              return v.id == 6;
            });
            if (!isQu) {
              this.serveList.push({
                name: "渠道管理",
                icon: "https://ttxres.ttxgm.com/promote_zs_static/promote_edit.png",
                url: "/home/son_list",
                id: 6,
                show: false
              });
            }
            let isBu = this.sysList.some(v => {
              return v.id == 22;
            });
            if (!isBu) {
              this.sysList.push({
                name: "游戏补点",
                icon: "https://ttxres.ttxgm.com/promote_zs_static/game_bu.png",
                url: "/home/bu_dot",
                id: 22,
                show: false
              });
            }

            let isDeposit = this.sysList.some(v => {
              return v.id == 19;
            });
            // if (!isDeposit) {
            //   this.sysList.push({
            //     name: '下级提现',
            //     icon: 'https://ttxres.ttxgm.com/promote_zs_static/lower_cash.png',
            //     url: '/home/lower_cash',
            //     id: 19,
            //     show: false
            //   })
            // }
            let isJie = this.sysList.some(v => {
              return v.id == 20;
            });
            // if (!isJie) {
            //   this.sysList.push({
            //     name: '下级结算',
            //     icon: 'https://ttxres.ttxgm.com/promote_zs_static/lower_final.png',
            //     url: '/home/lower_final',
            //     id: 20,
            //     show: false
            //   })
            // }

            let isBrecored = this.dataList.some(v => {
              return v.id == 23;
            });
            if (!isBrecored) {
              this.dataList.push({
                name: "补点记录",
                icon: "https://ttxres.ttxgm.com/promote_zs_static/bu_recored.png",
                url: "/home/dot_recored",
                id: 23,
                show: false
              });
            }
            let isTotal = this.dataList.some(v => {
              return v.id == 21;
            });
            // if (!isTotal) {
            //   this.dataList.push({
            //     name: '结算汇总',
            //     icon: 'https://ttxres.ttxgm.com/promote_zs_static/final_total.png',
            //     url: '/home/final_total',
            //     id: 21,
            //     show: false
            //   })
            // }
          }
          let isThreeGame = this.serveList.some(v => {
            return v.id == 28;
          });
          if (!isThreeGame && this.userInfo.is_third_game) {
            this.serveList.push({
              name: "第三方游戏",
              icon: "https://ttxres.ttxgm.com/promote_zs_static/bu_recored.png",
              url: "/mine/three_game",
              id: 28,
              show: false
            });
          }
          let isBackPtb = this.sysList.some(v => {
            return v.id == 34;
          })
          if (!isBackPtb && this.userInfo.can_ptb_recovery) {
            this.sysList.push({
              name: "平台币收回",
              icon: "https://ttxres.ttxgm.com/promote_zs_static/daicc.png",
              url: "/mine/substitute_back",
              id: 34,
              show: false
            });
          }
          if (this.userInfo.is_third_game == 0) {
            let threeIndex = this.serveList.findIndex((v) => {
              return v.id == 28
            })
            if (threeIndex >= 0) {
              this.serveList.splice(threeIndex, 1)
            }
          }
          let playerRule = this.userInfo.recharge_user_ptb
          let indexPlat = this.dataList.some(v => {
            return v.id == 31
          })
          if (playerRule == 1 && !indexPlat) {
            this.dataList.push({
              name: "平台币代充记录",
              icon: "https://ttxres.ttxgm.com/promote_zs_static/user_login_record.png",
              url: "/mine/playerplat_list",
              id: 31,
              show: false
            })
          }
          this.getMenu();
          this.dialogMenu = true;
          return;
        }
        if (
          v.url == "/home/substitute" &&
          (this.userInfo.is_admin == 1 || this.userInfo.is_admin == 2) &&
          this.userInfo.promote_level == 1
        ) {
          this.dialogModal = true;
        } else if (
          v.url == "/home/substitute" &&
          this.userInfo.promote_level != 1 &&
          this.userInfo.is_surcharge != 1
        ) {
          this.$message({
            message: "暂未开放",
            type: "warning"
          });
        } else {
          this.$router.push({
            path: v.url
          });
        }
      },
      removeMenu(k) {
        this.diaMenuList.splice(k, 1);
        this.topDelete(this.diaMenuList, this.serveList);
        this.topDelete(this.diaMenuList, this.sysList);
        this.topDelete(this.diaMenuList, this.dataList);
        this.topDelete(this.diaMenuList, this.cashList);
      },
      topDelete(topList, targetList) {
        let ids = [];

        topList.forEach(v => {
          targetList.forEach((vv, kk) => {
            if (v.id == vv.id) {
              ids.push(v.id);
              vv.show = true;
            }
          });
        });
        targetList.forEach(v => {
          if (ids.includes(v.id)) {
            v.show = false;
          } else {
            v.show = true;
          }
        });
      },
      serviceCheck(v) {
        this.addMenu(v, this.diaMenuList, this.serveList);
      },
      addMenu(v, topList, targetList) {
        if (topList.length >= 6) {
          this.$message({
            message: "最多添加6个",
            type: "warning"
          });
          return;
        }
        let ids = [];
        topList.push(v);
        topList.forEach(v => {
          targetList.forEach((vv, kk) => {
            if (v.id == vv.id) {
              ids.push(v.id);
              vv.show = true;
            }
          });
        });
        targetList.forEach(v => {
          if (ids.includes(v.id)) {
            v.show = false;
          } else {
            v.show = true;
          }
        });
      },
      sysCheck(v) {
        this.addMenu(v, this.diaMenuList, this.sysList);
      },
      dataCheck(v) {
        this.addMenu(v, this.diaMenuList, this.dataList);
      },
      cashCheck(v) {
        this.addMenu(v, this.diaMenuList, this.cashList);
      },
      confirmEdit() {
        if (this.diaMenuList.length < 6) {
          this.$message({
            message: "请选择6个菜单",
            type: "warning"
          });
          return;
        }
        updateMenu({
          homepage_menus: JSON.stringify(this.diaMenuList)
        }).then(res => {
          if (res.code === 200) {
            this.dialogMenu = false;
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.getMenu();
          }
        });
      },
      jumpExtension(id) {
        let extensionIndex = this.$parent.menuRecoredList.findIndex((v) => {
          return v.name == 'extension'
        })
        if (extensionIndex > 0) {
          this.$parent.menuRecoredList.splice(extensionIndex, 1)
        }
        this.$router.push({
            name: 'extension',
            query: {
              keyword: id,
              type: 'topSearch'
            }
          },
          () => {}
        )
      },
      jumpNew() {
        let extensionIndex = this.$parent.menuRecoredList.findIndex((v) => {
          return v.name == 'extension'
        })
        if (extensionIndex > 0) {
          this.$parent.menuRecoredList.splice(extensionIndex, 1)
        }
        this.$router.push({
          name: 'extension',
          query: {
            type: 'new'
          }
        })
      }
      // testDb: throttle(() => {
      //   console.log('封装节流函数')
      // }, 2000)

    }
  };
</script>
</script>
<style scoped lang="less">
@charge_width: 300px;
@charge_height: 100px;

.charge_box_style {
  // width: 380px;
  // height: 100px;
  // border-radius: 10px;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  // color: white;
}

.box {
  display: flex;


  .wrapper_box {
    width: 100%;

    .charge_box {
      display: flex;
      justify-content: space-between;
      height: 120px;
      background-color: white;
      border-radius: 4px;
      padding: 24px;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;

      .buff {
        width: 120px;
        height: 25px;
        background-color: #29d894;
        color: white;
        font-size: 14px;
        text-align: center;
        line-height: 25px;
        position: absolute;
        right: -26px;
        transform: rotate(45deg);
        top: 21px;
      }

      .user_info {
        display: flex;
        align-items: center;

        .user_img {
          width: 72px;
          height: 72px;
          border-radius: 50%;
        }

        .welcome_nick_name {
          margin-left: 5px;

          .welcome_word {
            font-weight: bold;
            font-size: 18px;
            margin-top: 10px;
          }

          .nick_name {}
        }
      }

      .data_box {
        display: flex;
        align-items: center;
        margin-right: 20px;
      }

      .month_charge {

        color: #29d894;
        text-align: center;
        padding: 0 25px;
        position: relative;

        &:nth-child(2) {
          &:before {
            content: '';
            width: 1px;
            height: 30px;
            background-color: #0000000f;
            position: absolute;
            left: 0px;
            top: 50%;
            transform: translateY(-50%);
          }

          &::after {
            content: '';
            width: 1px;
            height: 30px;
            background-color: #0000000f;
            position: absolute;
            right: 0px;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        &:nth-child(4) {
          &::after {
            content: '';
            width: 1px;
            height: 30px;
            background-color: #0000000f;
            position: absolute;
            right: 0px;
            top: 50%;
            transform: translateY(-50%);
          }

          &:before {
            content: '';
            width: 1px;
            height: 30px;
            background-color: #0000000f;
            position: absolute;
            left: 0px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .text {
        font-size: 14px;
        color: #00000073;
      }

      .num {
        margin-top: 10px;
        font-size: 24px;
        font-family: "font";
      }
    }

    .home_con {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }

    .home_right {
      width: 430px;
      flex-shrink: 0;
      margin-top: 20px;

      .quick_box {
        width: 430px;
        background-color: white;
        border-radius: 10px;

        .quick_top {
          display: flex;
          justify-content: space-between;
          padding: 0 20px;
          box-sizing: border-box;
          height: 68px;
          align-items: center;
          position: relative;
          border-bottom: 1px solid #f0f0f0;

          &:before {
            content: "";
            width: 3px;
            border-radius: 3px;
            background-color: #29d894;
            height: 28px;
            position: absolute;
            left: 0;
            top: 20px;
          }

          .title {
            font-size: 18px;
            font-weight: bold;
          }

          .edit_word {
            font-size: 13px;
            color: #29d894;
          }
        }

        .menu_box {
          display: flex;
          flex-wrap: wrap;
          min-height: 272px;

          .menu_item {
            width: 215px;
            height: 68px;
            border-bottom: 1px solid #f0f0f0;
            box-sizing: border-box;
            position: relative;
            font-size: 14px;
            display: flex;
            align-items: center;
            cursor: pointer;
            justify-content: center;
            transition: all 0.3s;


            .menu_img {
              width: 40px;
              height: 40px;
            }

            .menu_word {
              margin-left: 5px;
            }

            &:hover {
              // border: none !important;
              // transform: translate3d(15px, 0, 0);
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
              background: repeating-linear-gradient(to left,
              #29d89440,
              #ff979740);
              // transform: scale(1.1);
              // box-shadow: 1px 0 0 0 #f0f0f0, 0 1px 0 0 #f0f0f0, 1px 1px 0 0 #f0f0f0, inset 1px 0 0 0 #f0f0f0, inset 0 1px 0 0 #f0f0f0;
            }

            &:nth-child(1n) {
              &::after {
                content: "";
                width: 1px;
                height: 68px;
                position: absolute;
                right: 0;
                top: 0;
                background-color: #f0f0f0;
              }
            }

            &:nth-child(n + 8):nth-child(-n + 9) {
              border: none;
            }
          }
        }
      }
    }

    .notice_box {
      margin: 20px 20px 20px 0px;
      background-color: white;
      padding: 10px 20px 0 20px;
      box-sizing: border-box;
      border-radius: 10px;
      width: 68vw;
      flex-shrink: 0;
      height: 440px;

      .title_box {
        display: flex;
        align-items: center;

        .title {
          margin-left: 5px;
        }
      }

      .notice_con {
        // height: 260px;
        min-height: 210px;
        word-wrap: break-word;
      }

      .page_box {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

      .notice_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 42px;
        cursor: pointer;
        font-size: 14px;

        &:hover {
          // background-color: #29d89420;
          background: repeating-linear-gradient(to left,
          #ff979740,
          #8bb8f520,
          #29d89440);
          border-radius: 3px;
        }

        .time {
          color: #394d60;
          flex-shrink: 0;
        }

        .item_title {
          display: flex;
          align-items: center;
        }

        .dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #29d894;
        }

        .title {
          margin-left: 10px;
          font-size: 16px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 955px;

          .red_dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: red;
            display: inline-block;
          }
        }
      }

      .notice_tabs {
        display: flex;
        height: 40px;
        line-height: 40px;
        border-bottom: 2px solid #e4e7ed;
        position: relative;
        box-sizing: border-box;

        .tabs_item {
          margin-left: 20px;
          color: #303133;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          position: relative;

          &:hover {
            color: #29d894;
          }

          &:first-child {
            margin-left: 0;
          }
        }

        .tab_dot {
          // width: 6px;
          // height: 6px;
          border-radius: 50%;
          background-color: red;
          position: absolute;
          top: 6px;
          right: -12px;
          font-size: 10px;
          color: white;
          border-radius: 50%;
          height: 12px;
          line-height: 12px;
          text-align: center;
          padding: 0 2px;
        }

        .a_tabs {
          color: #29d894;
        }

        .tabs_line {
          position: absolute;
          height: 2px;
          background: #29d894;
          bottom: -2px;
          width: 20px;
          left: 0;
          transition-property: -webkit-transform;
          transition-property: transform;
          transition-property: transform, -webkit-transform;
          transition-duration: 0.3s;
        }
      }
    }
  }
}

.notice_con {
  position: relative;
  z-index: 99;
  word-wrap: break-word !important;
  text-wrap: wrap !important;
  // max-height: 500px;
  // overflow: scroll;


  // &::-webkit-scrollbar {
  //   width: 0;
  // }
}

.notice_list_box {
  //height: 210px;

  /deep/ .el-empty {
    padding: 0;

    .el-empty__description {
      margin-top: 10px;
    }
  }
}

.dia_menu {
  /deep/ .el-dialog__header {
    padding: 0 !important;
    height: 0;
  }

  /deep/ .el-dialog__body {
    padding: 0 20px 30px 20px;
  }
}

.dialog_menu_box {
  .menu_top {
    display: flex;
    align-items: center;

    .search_box {
      margin-top: 20px;
      margin-left: 30px;
      display: flex;
      align-items: center;

      .s_input {
        position: relative;

        .result_box {
          position: absolute;
          z-index: 99;
          left: 0;
          top: 45px;
          background-color: white;
          border: 1px solid #e9f1f5;
          border-radius: 3px;
          width: 217px;
          box-sizing: border-box;

          .res_item {
            height: 30px;
            line-height: 30px;
            padding-left: 17px;
            cursor: pointer;

            &:hover {
              background-color: #a9efd4;
            }
          }
        }
      }
    }
  }

  .menu_title_box {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: baseline;

    .menu_title {
      position: relative;
      margin-top: 20px;

      &:before {
        content: "";
        position: absolute;
        left: -20px;
        height: 20px;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        background-color: #29d894;
        border-radius: 4px;
      }
    }

    .title_tip {
      font-size: 13px;
      margin-left: 5px;
      font-weight: normal;
    }
  }

  .dmenu_box {
    display: flex;
    flex-wrap: wrap;

    .dmenu_item {
      margin-top: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #f8f9fd;
      border-radius: 5px;
      padding: 5px 10px;
      box-sizing: border-box;
      width: 250px;
      margin-right: 15px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .dmenu_left {
        display: flex;
        font-size: 14px;
        align-items: center;
        flex: 1;

        .dmenu_icon {
          width: 35px;
          height: 35px;
        }

        .dmenu_name {
          margin-left: 5px;
        }
      }
    }
  }
}



.per_top {
  margin-top: 20px;
  background-color: white;
  padding: 0 20px 0 20px;
  box-sizing: border-box;
  border-radius: 10px;
  width: 68vw;
  flex-shrink: 0;
  height: 660px;

  .title_more {
    display: flex;
    justify-content: space-between;
    height: 60px;
    align-items: center;

    .title_per {
      position: relative;
      font-size: 18px;
      font-weight: bolder;

      &:before {
        content: "";
        width: 3px;
        border-radius: 3px;
        background-color: #29d894;
        height: 24px;
        position: absolute;
        left: -20px;
        top: 0;
      }
    }

    .more {
      font-size: 15px;
      color: #29d894;
      cursor: pointer;
    }
  }

  .fee_box {
    height: 580px;
    background-color: #f0f2f5;
    position: relative;
    border-radius: 6px;
    // width: 853px;
    width: 65vw;
    // margin: 0 auto;
    overflow: hidden;

    .fee_img {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50%;
      position: absolute;
      opacity: 1;
      top: 0;
      left: 0;
      background-color: #f0f2f5;
      transition: opacity .3s;
      cursor: pointer;
    }

    .scroll_desc_btn {


      z-index: 11;


    }

    .scroll_desc {
      position: absolute;
      bottom: 30px;
      left: 320px;
      color: white;
      width: 500px;
    }

    .scroll_btn {
      position: absolute;
      bottom: 50px;
      right: 30px;
    }

    .left_sroll {
      position: absolute;
      z-index: 5;
      background: rgba(0, 0, 0, .3);
      min-width: 84px;
      width: 260px;
      height: 100%;
      left: 0;
      top: 0;
      overflow: hidden;
      transition: width .2s;


      ::-webkit-scrollbar {
        width: 0;
        height: 0;
      }

      .scroll_box {
        padding-top: 22px;
        width: 260px;
        overflow-y: scroll;
        height: 100%;
        position: relative;
        scroll-behavior: smooth;

        .comer {
          position: absolute;
          left: -2px;
          top: 35px;
          transform: rotate(90deg);
          transition: all .4s;
          // width: 0;
          // height: 0;
          // border: 14px solid;
          // border-radius: 5px;
          // border-color: transparent transparent transparent yellowgreen;
        }



        .scroll_item {
          margin-bottom: 22px;
          display: flex;
          align-items: center;
          margin-left: 25px;
          cursor: pointer;
          position: relative;
          z-index: 10;

          .fee_img_box {
            position: relative;
            width: 48px;
            height: 48px;
            overflow: hidden;
            box-sizing: border-box;
            border-radius: 10px;

            .add_speed {
              width: 50px;
              height: 20px;
              background-color: #29d894;
              color: white;
              font-size: 12px;
              text-align: center;
              line-height: 20px;
              position: absolute;
              right: -14px;
              -webkit-transform: rotate(44deg);
              transform: rotate(44deg);
              top: 1px;
            }
          }

          .scroll_icon {
            width: 48px;
            height: 48px;
            box-sizing: border-box;
            border-radius: 8px;
          }

          .item_info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 48px;
            margin-left: 5px;

            .s_name_suffix {
              display: flex;
              font-size: 14px;

              .s_name {

                color: white;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .s_suffix {
                font-size: 13px;
                color: #29d894;
                margin-left: 8px;
                flex-shrink: 0;
                border: 1px solid #29d894;
                line-height: 20px;
                padding: 0 5px;
                border-radius: 20px;
                box-sizing: border-box;
              }
            }

            .scroll_type {
              display: flex;
              align-items: center;

              .s_type_item {
                height: 16px;
                padding: 0 4px;
                line-height: 16px;
                margin-right: 4px;
                border-radius: 2px;
                background: #e6e8ef;
                font-size: 10px;
                color: #394d60;
                font-weight: 400;

              }
            }
          }
        }
      }
    }
  }

  .per_item {
    display: flex;
    align-items: center;
    margin-top: 15px;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      // background-color: #29d89420;
      background: repeating-linear-gradient(to left,
      #29d89440,
      #8bb8f520,
      #ff979740);
      border-radius: 10px;
    }

    .top_num1 {
      background: #29d894 !important;
      color: white !important;
    }

    .top_num2 {
      background: #ff9797 !important;
      color: white !important;
    }

    .top_num3 {
      background: #8bb8f5 !important;
      color: white !important;
    }

    .top_num {
      width: 24px;
      height: 24px;
      border-radius: 2px;
      flex-shrink: 0;
      margin-right: 20px;
      font-size: 15px;
      font-family: "font";
      background-color: #eef2ff;
      color: black;
      text-align: center;
      line-height: 24px;

      // &:nth-child(1) {
      //   background: #29d894;
      //   color: white;
      // }

      // &:nth-child(2) {
      //   background: #FF9797;
      //   color: white;
      // }

      // &:nth-child(3) {
      //   background: #8bb8f5;
      //   color: white;
      // }
    }

    .per_img {
      width: 70px;
      height: 70px;
    }

    .per_name_suffix {
      display: flex;
      margin-left: 35px;
      // width: 200px;
      flex: 1;

      .name {
        font-size: 14px;
        font-weight: bolder;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .suffix {
        font-size: 14px;
        color: #29d894;
        margin-left: 8px;
        flex-shrink: 0;
      }
    }

    .type_box {
      display: flex;
      align-items: baseline;
      margin-left: 30px;
      // width: 150px;
      color: #394d60;
      flex: 1;

      .type_item {
        margin-left: 5px;
      }
    }

    .plat_box {
      display: flex;
      margin-left: 30px;
      // width: 80px;
      flex: 1;

      .plat_icon {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
    }

    .open_time {
      flex: 1;

      .serve {
        color: #29d894;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 35px;
      }

      .time {
        color: #767676;
        margin-left: 35px;
        flex-shrink: 0;
      }
    }
  }

  /deep/ .el-loading-mask {
    background-color: transparent;
  }
}

.new_today {
  width: 430px;
  // height: 560px;
  margin-top: 20px;
  background-color: white;
  padding: 0 10px 0 10px;
  box-sizing: border-box;
  border-radius: 10px;
}

.pane_box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // height: 490px;

  .no_data {
    margin-left: 50%;
    margin-top: 50%;
    transform: translate(-50%, -50%);
  }
}

.new_game_box {
  display: flex;
  margin-top: 13px;
  cursor: pointer;

  &:hover {
    background: repeating-linear-gradient(to left,
    #29d89440,
    #8bb8f520,
    #ff979740);
    border-radius: 10px;
  }

  &:first-child {
    margin-top: 0;
  }

  .new_icon_box {
    width: 70px;
    height: 70px;
    overflow: hidden;
    position: relative;

    .add_speed {
      width: 70px;
      height: 20px;
      background-color: #29d894;
      color: white;
      font-size: 12px;
      text-align: center;
      line-height: 20px;
      position: absolute;
      right: -21px;
      -webkit-transform: rotate(43deg);
      transform: rotate(43deg);
      top: 3px;
    }
  }

  .new_icon {
    width: 70px;
    height: 70px;
  }

  .new_info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 70px;
    margin-left: 10px;
    padding: 5px 0;
    box-sizing: border-box;

    .new_name_suffix {
      display: flex;
      align-items: center;

      .name {
        font-size: 17px;
        font-weight: bolder;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .suffix {
        flex-shrink: 0;
        border: 1px solid #29d894;
        color: #29d894;
        border-radius: 10px;
        font-size: 13px;
        padding: 0 5px;
        line-height: 20px;
        // vertical-align: text-bottom;
        height: 20px;
        // margin-top: 5px;
        margin-left: 8px;
      }
    }

    .type_plat {
      display: flex;

      .type_box {
        display: flex;
        font-size: 14px;
        color: #394d60;

        .type_item {
          margin-left: 8px;
          background: #fafafa;
          border: 1px solid #d9d9d9;
          line-height: 20px;
          padding: 0 3px;

          &:first-child {
            margin-left: 0;
          }
        }
      }

      .plat_box {
        display: flex;

        .plat_icon {
          width: 20px;
          height: 20px;
          margin-left: 8px;
        }
      }
    }
  }
}

.more_box {
  width: 100%;
  height: 32px;
  border-radius: 5px;
  background-color: #29d894;
  text-align: center;
  line-height: 32px;
  color: white;
  font-size: 16px;
  margin-top: 8px;
  cursor: pointer;
}

.no_data_per {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 99;
}

.new_game_wap {
  background-color: white;
  padding: 0 20px 20px;
  border-radius: 10px;

  .title_more {
    display: flex;
    justify-content: space-between;
    height: 60px;
    align-items: center;

    .title_per {
      position: relative;
      font-size: 18px;
      font-weight: bolder;

      &:before {
        content: "";
        width: 3px;
        border-radius: 3px;
        background-color: #29d894;
        height: 24px;
        position: absolute;
        left: -20px;
        top: 0;
      }
    }

    .more {
      font-size: 15px;
      color: #29d894;
      cursor: pointer;
    }
  }

  .new_game_con {
    // display: flex;
    // flex-wrap: wrap;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    /* 每列占用1/4的容器宽度 */
    gap: 15px 15px;

    /* 行间距为10px，列间距为20px */
    .new_game_item {
      // width: 380px;
      // margin-right: 13px;
      // cursor: pointer;
      // margin-bottom: 15px;

      &:hover .img_new {
        transform: scale(1.2);

      }

      &:nth-child(4n) {
        margin-right: 0;
      }

      .img_box {
        overflow: hidden;
        width: 100%;
        // width: 380px;
        height: 200px;
        border-radius: 8px;

        .img_new {
          width: 100%;
          // width: 380px;
          height: 200px;
          transition: all .5s;
        }
      }

      .new_img_info {
        display: flex;
        margin-top: 10px;
        align-items: center;
        justify-content: space-between;

        .new_img_box {
          width: 70px;
          height: 70px;
          position: relative;
          overflow: hidden;

          .add_speed {
            width: 70px;
            height: 20px;
            background-color: #29d894;
            color: white;
            font-size: 12px;
            text-align: center;
            line-height: 20px;
            position: absolute;
            right: -21px;
            -webkit-transform: rotate(43deg);
            transform: rotate(43deg);
            top: 3px;
          }
        }

        .img_icon {
          width: 70px;
          height: 70px;
          border-radius: 15px;
        }

        .new_info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 2px 0;
          height: 70px;
          box-sizing: border-box;
          // margin: 0 8px 0 12px;
          width: 212px;

          .game_suffix {
            display: flex;

            .game {
              font-size: 14px;
              color: #191b1b;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .suffix {
              font-size: 14px;
              color: #29d894;
              margin-left: 8px;
              flex-shrink: 0;
              border: 1px solid #29d894;
              line-height: 20px;
              padding: 0 5px;
              border-radius: 20px;
            }
          }

          .new_types {
            display: flex;

            .new_type_item {
              height: 16px;
              padding: 0 4px;
              line-height: 16px;
              margin-right: 4px;
              border-radius: 2px;
              background: #e6e8ef;
              font-size: 10px;
              color: #394d60;
            }
          }

          .desc {
            font-size: 12px;
            color: #444;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .serve_time {
            display: flex;
            font-size: 14px;
            align-items: center;

            .serve {
              color: #29d894;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .time {
              color: #767676;
              margin-left: 6px;
              flex-shrink: 0;
            }
          }
        }
      }
    }
  }
}

/deep/ .el-dialog__header {
  position: relative;
  z-index: 99;
}

/deep/.notice_height {
  .el-dialog__body {
    max-height: 70vh;
    overflow: auto;
  }

}

.contract_tip {
  color: red;
}

.contract_dialog {
  z-index: 99999 !important;
}

/deep/ img {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue